import { Component, OnInit } from '@angular/core';
import { ComponentBase } from 'src/app/main/dynamic/component-base';
import { AttributeModel } from 'src/app/main/dynamic/model/attribute.model';

@Component({
  selector: 'app-text',
  templateUrl: './text.component.html',
  styleUrls: ['./text.component.scss']
})
export class TextComponent extends ComponentBase implements OnInit {

  constructor() { super() }

  ngOnInit() {
  }

  getOptionByKey(attribute: AttributeModel, key: string): string {
    let baseResult = super.getOptionByKey(attribute, key)

    if(baseResult) {
      return baseResult
    }

    return "false"
  }
}
